import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { PacmanLoader } from "react-spinners";

function SLMSearchPageShell({
  title,
  isLoading,
  onSubmit,
  onClear,
  filterPanel,
  resultsPanel,
  topActions,
  headerExtras,
  searchButtonLabel = "Search",
  clearButtonLabel = "Clear Filters",
  showDefaultActions = true,
  filterDensity = "normal",
  leftColumnProps = { md: 3, lg: 2 },
  rightColumnProps = { md: 9, lg: 10 },
  className,
}) {
  const filterDensityClass =
    filterDensity === "compact"
      ? "slm-search-filters-compact"
      : filterDensity === "tight"
        ? "slm-search-filters-tight"
        : "";

  return (
    <div className={className}>
      {isLoading && (
        <div className="outer-div">
          <div className="sweet-loading inner-div">
            <PacmanLoader
              css="display: block; margin: 0 auto; border-color: red"
              sizeUnit="px"
              size={20}
              color="#e03c31"
              loading={isLoading}
            />
          </div>
        </div>
      )}

      {!isLoading && (
        <Container fluid>
          {headerExtras}
          <Row>
            <Col sm={12} md={12} lg={12}>
              <p>
                <b>{title}</b>
              </p>
            </Col>
          </Row>
          <Row>
            <Col {...leftColumnProps}>
              <Form onSubmit={onSubmit}>
                {showDefaultActions && (
                  <Row className="gap-2 mb-3">
                    <Col xs="auto">
                      <Button type="submit" size="sm" id="submit">
                        {searchButtonLabel}
                      </Button>
                    </Col>
                    <Col xs="auto">
                      <Button type="button" size="sm" onClick={onClear}>
                        {clearButtonLabel}
                      </Button>
                    </Col>
                  </Row>
                )}

                {showDefaultActions && <hr />}
                {topActions}
                <div className={filterDensityClass}>{filterPanel}</div>
              </Form>
            </Col>

            <Col {...rightColumnProps}>
              <Row>
                <Col sm={12} md={12} lg={12}>
                  {resultsPanel}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
}

export default SLMSearchPageShell;
